// import {v4 as uuidv4} from 'uuid';
// import brand1 from '../../assets/img/brand-logo/b1.png';
// import brand2 from '../../assets/img/brand-logo/b2.png';
// import brand3 from '../../assets/img/brand-logo/b3.png';
// import brand4 from '../../assets/img/brand-logo/b4.png';
// import brand5 from '../../assets/img/brand-logo/b5.png';


// const brandCarouselOneData = [
//     {
//         id: uuidv4(),
//         brand: brand1,
//         name: 'Google'
//     },

//     {
//         id: uuidv4(),
//         brand: brand2,
//         name: 'Google'
//     },

//     {
//         id: uuidv4(),
//         brand: brand3,
//         name: 'Google'
//     },

//     {
//         id: uuidv4(),
//         brand: brand4,
//         name: 'Google'
//     },

//     {
//         id: uuidv4(),
//         brand: brand5,
//         name: 'Google'
//     },
    
// ]

// export default brandCarouselOneData;

import slide1 from '../../assets/img/brand-logo/ABC.svg';
import slide2 from '../../assets/img/brand-logo/BANNARI.svg';
import slide3 from '../../assets/img/brand-logo/BHADRESH.svg';
import slide4 from '../../assets/img/brand-logo/EVEREADY.svg';
import slide5 from '../../assets/img/brand-logo/ITC.svg';
import slide6 from '../../assets/img/brand-logo/JAGANNATH.svg';  // Fixed path
import slide7 from '../../assets/img/brand-logo/LOUISDREYFUS.svg';
import slide8 from '../../assets/img/brand-logo/MAHARAJASHREE.svg';
import slide9 from '../../assets/img/brand-logo/N.K.PROTEINS.svg';
import slide10 from '../../assets/img/brand-logo/NBHC.svg';
import slide11 from '../../assets/img/brand-logo/NCML.svg';
import slide12 from '../../assets/img/brand-logo/OLAM.svg';
import slide13 from '../../assets/img/brand-logo/PRECOTMERIDIAN.svg';
import slide14 from '../../assets/img/brand-logo/REINHART.svg';
import slide15 from '../../assets/img/brand-logo/SELGROUP.svg';
import slide16 from '../../assets/img/brand-logo/SHIVA.svg';
import slide17 from '../../assets/img/brand-logo/SHREERAJMOTI.svg';
import slide18 from '../../assets/img/brand-logo/SRISARAVANA.svg';
import slide19 from '../../assets/img/brand-logo/SRISHANMUGAVEL.svg';
import slide20 from '../../assets/img/brand-logo/SUNNY.svg';
import slide21 from '../../assets/img/brand-logo/THEdmlGROUP.svg';
import slide22 from '../../assets/img/brand-logo/TONGZHOU.svg';
import slide23 from '../../assets/img/brand-logo/TRIDENTGROUP.svg';
import slide24 from '../../assets/img/brand-logo/VARDHMAN.svg';

const brandCarouselOneData = [
    { id: 1, brand: slide1, name: 'ABC' },
    { id: 2, brand: slide2, name: 'BANNARI' },
    { id: 3, brand: slide3, name: 'BHADRESH' },
    { id: 4, brand: slide4, name: 'EVEREADY' },
    { id: 5, brand: slide5, name: 'ITC' },
    { id: 6, brand: slide6, name: 'JAGANNATH' },
    { id: 7, brand: slide7, name: 'LOUIS DREYFUS' },
    { id: 8, brand: slide8, name: 'MAHARAJASHREE' },
    { id: 9, brand: slide9, name: 'N.K. PROTEINS' },
    { id: 10, brand: slide10, name: 'NBHC' },
    { id: 11, brand: slide11, name: 'NCML' },
    { id: 12, brand: slide12, name: 'OLAM' },
    { id: 13, brand: slide13, name: 'PRECOT MERIDIAN' },
    { id: 14, brand: slide14, name: 'REINHART' },
    { id: 15, brand: slide15, name: 'SEL GROUP' },
    { id: 16, brand: slide16, name: 'SHIVA' },
    { id: 17, brand: slide17, name: 'SHREE RAJMOTI' },
    { id: 18, brand: slide18, name: 'SRI SARAVANA' },
    { id: 19, brand: slide19, name: 'SRI SHANMUGAVEL' },
    { id: 20, brand: slide20, name: 'SUNNY' },
    { id: 21, brand: slide21, name: 'THE DML GROUP' },
    { id: 22, brand: slide22, name: 'TONGZHOU' },
    { id: 23, brand: slide23, name: 'TRIDENT GROUP' },
    { id: 24, brand: slide24, name: 'VARDHMAN' },
];

export default brandCarouselOneData;
